import { render } from "./LocationSunsureResults.vue?vue&type=template&id=f4f61154&scoped=true"
import script from "./LocationSunsureResults.vue?vue&type=script&lang=js"
export * from "./LocationSunsureResults.vue?vue&type=script&lang=js"

import "./LocationSunsureResults.vue?vue&type=style&index=0&id=f4f61154&lang=postcss&scoped=true"

import exportComponent from "/codebuild/output/src804629530/src/be-admin-portal/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4f61154"]])

export default __exports__